import React from 'react';

function FastCheckin({ color = '#335B70', ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M5.868 14.514c-.007-.766.008-1.534.05-2.292L1 12.223v2.292h4.868ZM6.144 9.93c.118-.8.278-1.571.487-2.292L1 7.64V9.93h5.144ZM7.58 5.348a9.632 9.632 0 0 1 1.821-2.293L1 3.056v2.292h6.58Z"
                fill="#007E45"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.032 6.929c1.996-3.685 6.525-5.013 10.127-2.97 3.602 2.042 4.9 6.674 2.904 10.358C19.354 19.315 8.84 23 8.84 23s-2.517-11.073.192-16.071Zm6.319 1.313c-1.436.026-2.58 1.238-2.555 2.706.025 1.469 1.21 2.64 2.645 2.614 1.436-.026 2.58-1.238 2.555-2.706-.025-1.468-1.21-2.64-2.645-2.614Z"
                fill={color}
            />
        </svg>
    );
}

export default FastCheckin;
